import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SignedImageProps {
  bucket: string;
  path: string;
  alt: string;
  className?: string;
  expiresIn?: number;
}

const cache = new Map<string, { url: string; expires: number }>();

export function SignedImage({ bucket, path, alt, className, expiresIn = 3600 }: SignedImageProps) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const key = `${bucket}/${path}`;
    const cached = cache.get(key);
    if (cached && cached.expires > Date.now() + 30_000) {
      setUrl(cached.url);
      return;
    }
    supabase.storage.from(bucket).createSignedUrl(path, expiresIn).then(({ data }) => {
      if (cancelled || !data?.signedUrl) return;
      cache.set(key, { url: data.signedUrl, expires: Date.now() + expiresIn * 1000 });
      setUrl(data.signedUrl);
    });
    return () => { cancelled = true; };
  }, [bucket, path, expiresIn]);

  if (!url) return <div className={className} style={{ minHeight: 120 }} />;
  return <img src={url} alt={alt} loading="lazy" className={className} />;
}
